import React, { Component } from "react";
import {
  Badge,
  Navbar,
  Nav,
  NavDropdown,
  Container,
  Modal,
  Button,
} from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import _ from "lodash";
import { isMobile, isIOS } from "react-device-detect";
import StarRatings from "react-star-ratings";

// Redux
import { connect } from "react-redux";
import * as actions from "../../redux/actions";

// Components
import Color from "../../assets/color";
import Icon from "../../components/Icon";

// UI Components
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import ModalSelectOrderType from "./ModalSelectOrderType";
import ModalTopUp from "./ModalTopUp";
import ModalClosed from "./ModalClosed";
import ModalLocation from "./ModalLocation";
import ModalAlertSetWalletPin from "./ModalAlertSetWalletPin";
import ModalProductPreference from "./ModalProductPreference";
import ModalDoNotShow from "./ModalDoNotShow";
import ModalDeliveryOperationHour from "./ModalDeliveryOperationHour";

// Styles
import HeaderStyled from "./style";
//
import { SETTINGS } from "../../constant/settings";

let lastScrollY = 0;

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showDownloadAppBar: isMobile
        ? localStorage.getItem("hideDownloadAppBar") !== "true"
        : false,
    };

    this.nav = React.createRef();
  }
  downloadApp = React.createRef();

  componentDidMount() {
    window.addEventListener("scroll", this._handleScroll, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this._handleScroll);
  }

  _handleScroll = () => {
    lastScrollY = window.scrollY;
    const downloadBar = this.downloadApp;
    var element = this.nav.current.firstChild;

    if (isMobile) {
      let downloadBarHeight = 0;

      if (downloadBar.current) {
        downloadBarHeight = downloadBar && downloadBar.current.clientHeight;
      }

      if (lastScrollY > downloadBarHeight) {
        if (!element.classList.contains("fixed-top")) {
          element.classList.add("fixed-top");
        }
      } else {
        element.classList.remove("fixed-top");
      }
    }
  };

  _goToSignUp = () => {
    this.props.onHideLoginModal();
    this.props.history.push("/register");
  };

  _onLogout = () => {
    const confirm = window.confirm("Are you sure you want to logout?");

    if (confirm) {
      this.props.onLogout();
    }
  };

  _showModalLogin = () => {
    this.props.onShowLoginModal();
  };

  _hideModalLogin = () => {
    this.props.onHideLoginModal();
  };

  _goToForgotPassword = () => {
    this.props.onSwitchLoginForgotPassword("forgot-password");
  };

  _goToLogin = () => {
    this.props.onSwitchLoginForgotPassword("login");
  };

  _handleNavSelect = (key) => {
    switch (key) {
      case "/login":
        this.props.onShowLoginModal();
        break;
      case "/logout":
        this._onLogout();
        break;
      case "/whatsapp":
        window.open(
          "https://wa.me/+" + this.props.whatsapp_no.replace("+", ""),
          "_blank"
        );
        // window.open(`https://lololivechat.wasap.my/`, "_blank");
        break;
      default:
        this.props.history.push(key);
        break;
    }
  };

  _hideDownloadAppBar = () => {
    this.setState({ showDownloadAppBar: false }, () => {
      localStorage.setItem("hideDownloadAppBar", true);
    });
  };

  render() {
    const {
      loginModalVisible,
      loginModalType,
      isLoggedIn,
      SMSSent,
      codeVerified,
      codeNotVerified,
      passwordReset,
      unreadNotification,
      location,
      profileDetail,
      consumerDetail,
      cartItems,
      cartRestaurant,
    } = this.props;

    const { showDownloadAppBar } = this.state;

    const currentPath = location.pathname;
    let total_cart = 0;
    let total_restaurant_cart = 0;
    let total_restaurant_and_mall_cart = 0;

    if (cartItems.data) {
      if (cartItems.data.length !== 0) {
        cartItems.data.forEach((data) => {
          data.item.forEach((data) => {
            total_cart += parseInt(data.quantity);
          });
        });
      }
    }

    if (cartRestaurant) {
      if (JSON.stringify(cartRestaurant) !== "{}") {
        Object.keys(cartRestaurant).forEach((key) => {
          if (
            !_.isNil(cartRestaurant[key].orderType) &&
            !_.isNil(cartRestaurant[key].items)
          ) {
            cartRestaurant[key].items.forEach((cartItem) => {
              total_restaurant_cart += parseInt(cartItem.quantity);
            });
          }
        });
      }
    }

    total_restaurant_and_mall_cart = total_cart + total_restaurant_cart;

    return (
      <HeaderStyled>
        {showDownloadAppBar && (
          <div className="download-app-container" ref={this.downloadApp}>
            <div className="app-info">
              <div className="close-icon" onClick={this._hideDownloadAppBar}>
                <Icon
                  type="material-icons"
                  name="close"
                  size={16}
                  style={{ alignSelf: "center", marginRight: 5 }}
                />
              </div>
              <img
                className="app-icon"
                src={require("../../assets/img/logo_app.png")}
                alt="LOLOL - Pay Less, Get More"
              />
              <div>
                <p className="app-name">LOLOL - Food Delivery</p>
                <StarRatings
                  rating={4}
                  starRatedColor={Color.primary}
                  starEmptyColor={Color.athens}
                  starDimension="12px"
                  starSpacing="1px"
                />
              </div>
            </div>
            <div>
              <Button
                href={
                  isIOS
                    ? "https://itunes.apple.com/my/app/lolol-pay-less-get-more/id1440552007?mt=8"
                    : "https://play.google.com/store/apps/details?id=com.lolol.userApp"
                }
                size="sm"
              >
                View
              </Button>
            </div>
          </div>
        )}
        <header ref={this.nav}>
          <Navbar
            collapseOnSelect
            expand="lg"
            bg="light"
            variant="light"
            fixed={showDownloadAppBar ? "null" : "top"}
          >
            <Container>
              <Navbar.Brand>
                <Link to="/" className="logo">
                  <img
                    src={require("../../assets/img/logo.png")}
                    alt="LOLOL - Pay Less, Get More"
                  />
                </Link>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="responsive-navbar-nav">
                {isLoggedIn && (
                  <img
                    src={profileDetail.profile_thumbnail}
                    className="mobile-profile-img"
                    alt=""
                  />
                )}
              </Navbar.Toggle>
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="ml-auto" activeKey={currentPath}>
                  {isLoggedIn && (
                    <Nav.Item className="d-lg-none profile-details">
                      <div className="d-flex align-items-center">
                        <span className="profile-name">
                          Welcome, {profileDetail.profile_name}
                        </span>
                      </div>
                    </Nav.Item>
                  )}

                  {this.props.whatsapp_no && this.props.whatsapp_no !== null ? (
                    <Nav.Item>
                      <Nav.Link
                        as="div"
                        eventKey="/whatsapp"
                        active={false}
                        onSelect={this._handleNavSelect}
                      >
                        <span className="icon-container">
                          <svg
                            height="20"
                            viewBox="0 0 18 18"
                            width="20"
                            style={{
                              width: "20px",
                              height: "20px",
                            }}
                          >
                            <path
                              d="m13.1460703 10.7880226c-.223174-.111869-1.3203713-.6528056-1.5249582-.7274708-.2045869-.07462226-.3533696-.11191195-.5021523.1118691-.1487827.2238669-.576458.7275566-.7066963.8768441-.1301528.1491588-.2603483.1679109-.48347953.055956-.22321685-.1119549-.94233316-.3480514-1.79477143-1.10993685-.66348341-.59290179-1.11137325-1.3251357-1.24156881-1.54904549-.13015272-.22382396-.01383327-.34483308.09790364-.45635886.10038762-.10019727.22317402-.26119948.33473962-.39173485.11160843-.13057828.14878269-.22390978.22317403-.37302563.07439134-.1492875.03721709-.27986578-.01858713-.39177776-.05580421-.11191198-.50215227-1.21262297-.68810921-1.66039962-.18116026-.43593322-.36514714-.37688763-.50215227-.38383922-.13002424-.00647957-.27897824-.00785272-.42771809-.00785272-.14878269 0-.39058667.05595599-.59513074.27977995-.2045869.22390979-.78113051.76488922-.78113051 1.86551438 0 1.10066807.79971764 2.16391771.91132606 2.3131623.1115656.14928749 1.57369596 2.40786697 3.81250276 3.37649777.53247413.2303893.94820051.368005 1.27227611.4709915.5346583.170271 1.0211786.1462408 1.4056837.0886542.4287888-.0641949 1.3204142-.5409365 1.506414-1.0632496.1859569-.522399.1859569-.9700898.1301527-1.0633355-.0557613-.0932886-.204544-.1492875-.4277181-.2612424m-4.14600587 5.5244774h-.00300481c-1.33516282-.0005109-2.64474189-.3562691-3.78721098-1.0287014l-.27167714-.159955-2.8162303.7327188.75167297-2.7233638-.17689705-.279208c-.74484778-1.1750323-1.13821944-2.5330527-1.137662-3.9275601.00163177-4.06908001 3.33962468-7.3795555 7.44397118-7.3795555 1.9874627.0006812 3.8557205.76937603 5.2605948 2.16435172 1.4048313 1.39493311 2.178053 3.24920981 2.1773238 5.22112173-.0016746 4.06942065-3.3396676 7.38015155-7.44088047 7.38015155m6.37738627-13.69672097c-1.6920847-1.68595901-3.9423532-2.61483813-6.33989212-2.61577903-4.93994185 0-8.96046398 4.00099317-8.96244076 8.91880487-.00064461 1.57206773.41203067 3.10649953 1.19634147 4.45921003l-1.27145929 4.6219851 4.75107297-1.2403588c1.30906117.7105911 2.78292602 1.0851536 4.2829188 1.0856668h.00365276.00004297c4.9394262 0 8.9603351-4.0014209 8.9623125-8.91936087.0009018-2.38324918-.9304646-4.62425185-2.6225493-6.3101681"
                              fill-rule="evenodd"
                            ></path>
                          </svg>
                        </span>
                        <span className="d-lg-none">WhatsApp LOLOL!</span>
                      </Nav.Link>
                    </Nav.Item>
                  ) : null}
                  <Nav.Item>
                    <Nav.Link
                      as="div"
                      eventKey="/"
                      active={false}
                      onSelect={this._handleNavSelect}
                    >
                      <span className="icon-container d-lg-none">
                        <Icon type="custom" name="home" size={20} />
                      </span>
                      <span>Home</span>
                    </Nav.Link>
                  </Nav.Item>
                  {isLoggedIn ? (
                    <React.Fragment>
                      <Nav.Item>
                        <Nav.Link
                          as="div"
                          eventKey="/cart"
                          onSelect={this._handleNavSelect}
                        >
                          <span className="icon-container">
                            <Icon type="custom" name="cart" size={20} />
                          </span>
                          {total_restaurant_and_mall_cart !== 0 && (
                            <Badge className="unread-notification">
                              {total_restaurant_and_mall_cart <= 99
                                ? total_restaurant_and_mall_cart
                                : "99+"}
                            </Badge>
                          )}

                          <span className="d-lg-none">Cart</span>
                        </Nav.Link>
                      </Nav.Item>
                      {/* <Nav.Item>
                        <Nav.Link
                          as="div"
                          eventKey="/recommended-restaurant"
                          onSelect={this._handleNavSelect}
                        >
                          <span className="icon-container">
                            <Icon
                              type="custom"
                              name="outlinemarker"
                              size={20}
                            />
                          </span>
                          <span className="d-lg-none">
                            Recommended Restaurant
                          </span>
                        </Nav.Link>
                      </Nav.Item> */}
                      <Nav.Item>
                        <Nav.Link
                          as="div"
                          eventKey="/notifications"
                          onSelect={this._handleNavSelect}
                        >
                          <React.Fragment>
                            <span className="icon-container">
                              <Icon
                                type="custom"
                                name="notification"
                                size={20}
                              />
                            </span>
                            {unreadNotification !== 0 && (
                              <Badge className="unread-notification">
                                {unreadNotification <= 99
                                  ? unreadNotification
                                  : "99+"}
                              </Badge>
                            )}
                            <span className="d-lg-none">Notification</span>
                          </React.Fragment>
                        </Nav.Link>
                      </Nav.Item>
                      <NavDropdown
                        id="collasible-nav-dropdown"
                        alignRight={true}
                        // show={true}
                        title={
                          <React.Fragment>
                            <img
                              src={profileDetail.profile_thumbnail}
                              className="profile-img d-none d-lg-block"
                              alt=""
                            />
                            <React.Fragment>
                              <span className="icon-container d-lg-none">
                                <Icon type="custom" name="profile" size={20} />
                              </span>
                              <span className="d-lg-none">Profile</span>
                            </React.Fragment>
                          </React.Fragment>
                        }
                      >
                        <NavDropdown.Item>
                          <Nav.Link
                            as="div"
                            eventKey="/my-profile/?tabs=profile-details"
                            onSelect={this._handleNavSelect}
                          >
                            My Profile
                          </Nav.Link>
                        </NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item
                          as="div"
                          eventKey="/my-profile/?tabs=restaurant-order"
                          onSelect={this._handleNavSelect}
                        >
                          My Order
                        </NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item>
                          <Nav.Link
                            as="div"
                            eventKey="/my-profile/?tabs=wallet"
                            onSelect={this._handleNavSelect}
                          >
                            My Wallet{" "}
                            <span className="wallet-balance">
                              Balance: RM{" "}
                              {profileDetail.wallet !== 0
                                ? isNaN(profileDetail.wallet)
                                  ? consumerDetail.wallet !== 0
                                    ? parseFloat(consumerDetail.wallet).toFixed(
                                        2
                                      )
                                    : "0.00"
                                  : parseFloat(profileDetail.wallet).toFixed(2)
                                : "0.00"}
                            </span>
                          </Nav.Link>
                        </NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item>
                          <Nav.Link
                            as="div"
                            eventKey="/my-profile/?tabs=voucher"
                            onSelect={this._handleNavSelect}
                          >
                            My Voucher
                          </Nav.Link>
                        </NavDropdown.Item>
                        <NavDropdown.Divider />
                        <NavDropdown.Item
                          as="div"
                          eventKey="/logout"
                          onSelect={this._handleNavSelect}
                          className="text-primary"
                        >
                          Logout
                        </NavDropdown.Item>
                      </NavDropdown>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <Nav.Item>
                        <Nav.Link
                          as="div"
                          href="/login"
                          onSelect={this._handleNavSelect}
                        >
                          Login
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          as="div"
                          href="/register"
                          onSelect={this._handleNavSelect}
                        >
                          Sign Up
                        </Nav.Link>
                      </Nav.Item>
                    </React.Fragment>
                  )}
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>

          {/* Modal Login */}
          <Modal
            size="lg"
            show={loginModalVisible}
            onHide={this._hideModalLogin}
            aria-labelledby="example-modal-sizes-title-lg"
            centered={true}
            backdrop="static"
          >
            {loginModalType === "login" ? (
              <Login
                onHide={this._hideModalLogin}
                // Function
                goToSignUp={this._goToSignUp}
                goToForgotPassword={this._goToForgotPassword}
                onSubmit={this.props.onLogin}
              />
            ) : (
              <ForgotPassword
                type={loginModalType}
                SMSSent={SMSSent}
                codeVerified={codeVerified}
                codeNotVerified={codeNotVerified}
                passwordReset={passwordReset}
                // Function
                goToLogin={this._goToLogin}
                onHide={this._hideModalLogin}
                onSentCode={this.props.onSendCode}
                onVerifyCode={this.props.onVerifyCode}
                onSubmit={this.props.onResetPassword}
              />
            )}
          </Modal>
          {/* END Modal Login */}

          <ModalSelectOrderType />
          <ModalTopUp />
          <ModalLocation />
          <ModalAlertSetWalletPin />
          <ModalProductPreference />
          <ModalDoNotShow />
          <ModalDeliveryOperationHour />
          {SETTINGS.closed && <ModalClosed />}
        </header>
      </HeaderStyled>
    );
  }
}

Header.propTypes = {
  loginModalVisible: PropTypes.bool.isRequired,
  loginModalType: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  SMSSent: PropTypes.bool.isRequired,
  codeVerified: PropTypes.bool.isRequired,
  codeNotVerified: PropTypes.bool.isRequired,
  passwordReset: PropTypes.bool.isRequired,
  unreadNotification: PropTypes.number.isRequired,
  profileDetail: PropTypes.object.isRequired,
  consumerDetail: PropTypes.object.isRequired,
  cartItems: PropTypes.object.isRequired,
  cartRestaurant: PropTypes.object.isRequired,
  // Function
  onLogin: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  onSendCode: PropTypes.func.isRequired,
  onVerifyCode: PropTypes.func.isRequired,
  onResetPassword: PropTypes.func.isRequired,
  onShowLoginModal: PropTypes.func.isRequired,
  onHideLoginModal: PropTypes.func.isRequired,
  onSwitchLoginForgotPassword: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    loginModalVisible: state.App.loginModalVisible,
    loginModalType: state.App.loginModalType,
    isLoggedIn: state.Auth.isLoggedIn,
    SMSSent: state.Auth.SMSSent,
    codeVerified: state.Auth.codeVerified,
    codeNotVerified: state.Auth.codeNotVerified,
    passwordReset: state.Auth.passwordReset,
    profileDetail: state.Auth.profileData,
    unreadNotification: state.Notification.unread_notification,
    cartItems: state.Mall.cartItems,
    cartRestaurant: state.App.cart,
    consumerDetail: state.Consumer.consumerDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogin: (params) => dispatch(actions.consumerLogin(params)),
    onLogout: () => dispatch(actions.consumerLogout()),
    onSendCode: (params) => dispatch(actions.sendSMS(params)),
    onVerifyCode: (params) => dispatch(actions.verifySMS(params)),
    onResetPassword: (params) => dispatch(actions.resetPassword(params)),
    onShowLoginModal: (params) => dispatch(actions.showLoginModal(params)),
    onHideLoginModal: () => dispatch(actions.hideLoginModal()),
    onSwitchLoginForgotPassword: (params) =>
      dispatch(actions.switchLoginForgotPassword(params)),
    onShowLocationModal: () => dispatch(actions.showModalLocation()),
    onHideLocationModal: () => dispatch(actions.hideModalLocation()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
